import { useCopyToClipboard } from "@uidotdev/usehooks";

import { ErrorIcon, Icon } from "../icon";

type Props = {
  details?: string;
  message: string;
};

export const ErrorToast = ({ message, details }: Props) => {
  const [value, copy] = useCopyToClipboard();

  return (
    <div className="flex items-start gap-x-5">
      <ErrorIcon />
      <div className="flex flex-col gap-y-0.5">
        <h5 className="line-clamp-3 overflow-hidden font-medium">{message}</h5>
        {details && (
          <p className="text-pickledBluewood line-clamp-4 text-sm">{details}</p>
        )}

        <button
          className="text-basketBallOrange mt-3 flex items-center gap-x-1.5"
          onClick={async () => {
            await copy(`message: ${message}; details: ${details}`);
          }}
        >
          <Icon
            className="text-basketBallOrange size-5 hover:brightness-105"
            name={value ? "verifiedCheck" : "copy"}
          />
          {value ? "Copied" : "Copy error message"}
        </button>
      </div>
    </div>
  );
};
